import * as React from "react";
import { Accordion, Card } from "react-bootstrap";
import './BeneficiaryDetail.css';
import './BeneficiaryPolicyPayout.css';

export interface BeneficiaryPolicyPayoutProps {
    beneficiaries: any;
    emitHandleUpdate: any;
}

export class BeneficiaryPolicyPayout extends React.Component<BeneficiaryPolicyPayoutProps,any> {
    
    constructor(props) {
        super(props);
        this.state = {
            updateReminderDismissed: false,
            selectedBenefit: {},
            isInEdit: false,
        }

        this.handleUpdate = this.handleUpdate.bind(this);
    }
    
    handleUpdate() {
        this.props.emitHandleUpdate();
    }
    
    public render() {
        const beneficiaries = this.props.beneficiaries;
        return (
            <div className="beneficiary-detail">
                <Card>

                    <Card.Body className="beneficiary-detail__card-body">
                        <Accordion>
                            <Accordion.Toggle as={Card.Header} variant="text" eventKey="0">
                                Policy payout
                            </Accordion.Toggle>
                            <Accordion.Collapse className="show beneficiary-detail__collapse beneficiary-detail__collapse--beneficiary-payout" eventKey="0">
                              <>
                                  <div className="row">
                                    { beneficiaries.map((beneficiary) =>
                                        <div className="beneficiary-detail__row justify-content-between row col-12">
                                            <div className="col-6 col-lg-3 align-self-center beneficiary-detail__name">
                                                <p>{ beneficiary.name }</p>
                                            </div>
                                            <div className="col-6 col-lg-2 align-self-center beneficiary-detail__percentage">
                                                <p className="font-weight-bold">{ beneficiary.percentage }%</p>
                                            </div>
                                            <div className="col-12 col-lg-7 beneficiary-detail__block row flex-column justify-content-center align-items-end">
                                                <p className="font-weight-bold">{ beneficiary.percentage }%</p>
                                                <div className="beneficiary-detail__outer">
                                                    <div style={{width: beneficiary.percentage + '%'}} data-beneficiary-id={beneficiary.id} id="beneficiary-policy-payout__percentage-block" className="beneficiary-detail__inner">
                                                    
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                  </div>
                                  <hr />
                                  <div className="row justify-content-end">
                                      <div>
                                          <button onClick={this.handleUpdate} className="btn beneficiary-detail__update-button mr-3">
                                              <img className="arrow" src={"/my-policy/Images/Claims/Edit-pen.png"} />
                                              Update
                                          </button>
                                      </div>
                                  </div>
                              </>
                            </Accordion.Collapse>
                        </Accordion>
                    </Card.Body>
                </Card>
            </div>
        )
    }
}